import {
  ASSIGN_TO,
  ASSIGNED_USER_ID,
  ASSIGNED_USER_NAME,
  TEAM,
  ASSIGNED_USER_ID_INITIAL_VALUE,
  ASSIGNED_USER_NAME_INITIAL_VALUE,
  ASSIGN_TO_INITIAL_VALUE,
  TEAM_INITIAL_VALUE,
  PRIORITY,
  START_DATE,
  START_DATE_INITIAL_VALUE,
  DUE_DATE,
  DUE_DATE_INITIAL_VALUE,
  START_DUE_DATE_RANGE,
  CHANGE_VERSION,
} from './base';
import {
  TASK_STATUS,
} from './tasks';
import {
  RECORD_LINKAGE,
  RECORD_LINKAGE_INITIAL_VALUES,
} from './record-linkage';

export const JOB_MODULE_NAME = 'job';

const INDEXES = [
  'jobName',
  'linkedRecord',
];

export const JOB_SEARCHABLE_INDEXES = [
  {
    labelId: 'ui-task-list.search.all',
    value: '',
  },
  ...INDEXES.map(index => ({
    labelId: `ui-task-list.job.search.${index}`,
    value: index,
  })),
];

export const JOB_ACTIONS = {
  STARTED: 'started',
  CANCELLED: 'cancelled',
  RESTARTED: 'restarted',
};

export const JOB_STATUSES = {
  CREATED: 'created',
  STARTED: 'started',
  ON_HOLD: 'on_hold',
  CANCELLED: 'cancelled',
  COMPLETED: 'completed',
};

export const ASSIGN_TASK_FIELDS = {
  ID: 'id',
  NAME: 'name',
  ASSIGN_TO,
  ASSIGNED_USER_NAME,
  ASSIGNED_USER_ID,
  TEAM,
  ASSIGNED: 'assigned',
  DESCRIPTION: 'description',
  START_DATE,
  DUE_DATE,
  PRIORITY: 'priority',
  STATUS: 'status',
};

export const ASSIGN_TASK_INITIAL_VALUES = {
  [ASSIGN_TASK_FIELDS.NAME]: '',
  [ASSIGN_TASK_FIELDS.DESCRIPTION]: '',
  [ASSIGN_TASK_FIELDS.ASSIGNED_USER_NAME]: ASSIGNED_USER_NAME_INITIAL_VALUE,
  [ASSIGN_TASK_FIELDS.ASSIGNED_USER_ID]: ASSIGNED_USER_ID_INITIAL_VALUE,
  [ASSIGN_TASK_FIELDS.ASSIGN_TO]: ASSIGN_TO_INITIAL_VALUE,
  [ASSIGN_TASK_FIELDS.TEAM]: TEAM_INITIAL_VALUE,
  [ASSIGN_TASK_FIELDS.START_DATE]: START_DATE_INITIAL_VALUE,
  [ASSIGN_TASK_FIELDS.DUE_DATE]: DUE_DATE_INITIAL_VALUE,
  [ASSIGN_TASK_FIELDS.PRIORITY]: PRIORITY.LOW,
  [ASSIGN_TASK_FIELDS.STATUS]: TASK_STATUS.CREATED,
};

export const JOB_FIELDS = {
  ID: 'id',
  JOB_TEMPLATE_ID: 'jobTemplateId',
  NAME: 'name',
  DESCRIPTION: 'description',
  START_DUE_DATE_RANGE,
  START_DATE,
  DUE_DATE,
  ASSIGN_TASK: 'tasks',
  TOTAL_TASKS: 'totalTasks',
  METADATA: 'metadata',
  STATUS: 'status',
  CHANGE_VERSION,
  RECORD_LINKAGE,
};

export const JOB_INITIAL_VALUES = {
  [JOB_FIELDS.NAME]: '',
  [JOB_FIELDS.DESCRIPTION]: '',
  [JOB_FIELDS.START_DUE_DATE_RANGE]: {},
  [JOB_FIELDS.START_DATE]: START_DATE_INITIAL_VALUE,
  [JOB_FIELDS.DUE_DATE]: DUE_DATE_INITIAL_VALUE,
  [JOB_FIELDS.ASSIGN_TASK]: [ASSIGN_TASK_INITIAL_VALUES],
  [JOB_FIELDS.STATUS]: JOB_STATUSES.CREATED,
  [JOB_FIELDS.RECORD_LINKAGE]: RECORD_LINKAGE_INITIAL_VALUES,
};

export const JOB_DEFAULT_SORT_FIELD = JOB_FIELDS.NAME;
